import React from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { FaUserGraduate, FaBook, FaScroll } from 'react-icons/fa';
import './style.css';

const Dashboard = () => {
  const navigate = useNavigate();

  const getPrograma = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return {
        tipo: Number(decoded.tipo_programa),
        tipoUsuario: decoded.tipo,
        isCiee: decoded.tipo === 'usuario_ciee',
        isEstudante: decoded.tipo === 'estudante',
        isEmpresa:
          decoded.tipo === 'empresa' ||
          decoded.tipo === 'usuario_externo',
      };
    } catch (e) {
      return null;
    }
  };

  const programa = getPrograma();

  const renderCards = () => {
    if (programa?.isCiee) {
      return (
        <>
          <div className="card-programa" onClick={() => navigate('/tce')}>
            <FaUserGraduate size={50} />
            <h3>Estágio (TCE)</h3>
            <p>Termo de Compromisso de Estágio</p>
          </div>
          <div className="card-programa" onClick={() => navigate('/tca')}>
            <FaBook size={50} />
            <h3>Aprendizagem (TCA)</h3>
            <p>Termo de Compromisso de Aprendizagem Empresa Empregadora</p>
          </div>
          <div className="card-programa" onClick={() => navigate('/tca-empregador')}>
            <FaScroll size={50} />
            <h3>Aprendizagem (TCA)</h3>
            <p>Termo de Compromisso de Aprendizagem CIEEMG Empregador</p>
          </div>
        </>
      );
    }

    if (programa?.isEstudante) {
      return (
        <div className="card-programa" onClick={() => navigate('/tca')}>
          <FaBook size={50} />
          <h3>Aprendizagem (TCA)</h3>
          <p>Termo de Compromisso de Aprendizagem</p>
        </div>
      );
    }

    if (programa?.isEmpresa) {
      if (programa.tipo === 0) {
        return (
          <div className="card-programa" onClick={() => navigate('/tce')}>
            <FaUserGraduate size={50} />
            <h3>Estágio (TCE)</h3>
            <p>Termo de Compromisso de Estágio</p>
          </div>
        );
      }
      if (programa.tipo === 1 || programa.tipo === 2) {
        return (
          <div className="card-programa" onClick={() => navigate('/tca')}>
            <FaBook size={50} />
            <h3>Aprendizagem (TCA)</h3>
            <p>Termo de Compromisso de Aprendizagem</p>
          </div>
        );
      }
      return <p>Nenhum programa vinculado à sua empresa.</p>;
    }

    return <p>Nenhum programa vinculado.</p>;
  };

  return (
    <div className="dashboard-container">
      <h1>Bem-vindo!</h1>
      <p>Selecione o programa desejado:</p>
      <div className="cards-programa">
        {renderCards()}
      </div>
    </div>
  );
};

export default Dashboard;
